<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <Tabs type="card" value="1" @on-click="handleClickTab">
        <TabPane label="服务管理" name="1"></TabPane>
        <TabPane label="服务管理（未合作）" name="2"></TabPane>
      </Tabs>
      <div class="search-wrapper">
        <Form
          ref="searchForm"
          label-position="right"
          :label-width="0"
          class="search-list-430 search-wrapper-430"
        >
          <Row class="relative" type="flex" flex="end">
            <FormItem label="">
              <Input
                v-model.trim="searchConds.searchStr"
                class="search-input-430"
                placeholder="请输入机构单位名称"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.orgKind"
                placeholder="请选择单位类别"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in orgKindList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Cascader
                v-model="searchConds.area"
                placeholder="请选择所属行政区"
                :data="regionDataList"
                @on-change="handelAreaChange"
              ></Cascader>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.coSts"
                placeholder="请选择合作状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in cooperationList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.infoSts"
                placeholder="请选择信息完善状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in completeStatusList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem v-if="userInfo.userType === 5 && active === 1" label="">
              <Select
                v-model="searchConds.reviewState"
                placeholder="请选择教育局审批状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in reviewStateList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>

            <Button type="primary" @click="handleSearch">查询</Button>
            <Button class="search-430" @click="handleReset">重置</Button>
          </Row>
        </Form>
      </div>
      <div class="table-title-special-430 flex justify-content_end">
        <div class="">
          <Button
            class="op-btn"
            type="primary"
            @click="handleRecommend"
          >推荐至教育局</Button>
          <!-- <EditButton
          redirect-url="operatingCenter/organization/org/Index"
          class="search-430"
        ></EditButton> -->
        </div>
      </div>
    </div>

    <div class="main-wrapper">
      <div class="table">
        <Table
          ref="selection"
          border
          :max-height="tableHeight"
          :columns="tableColumns"
          :data="tableData"
          :loading="tableLoading"
          @on-selection-change="handleSelectData"
        >
          <template slot="action" slot-scope="{ row }">
            <span
              class="ordinary-color-430"
              style="margin-right: 6px"
              @click="handleToMage(row)"
            >管理</span>
            <span
              class="ordinary-color-430"
              @click="handleToDetail(row)"
            >查看详情</span>
          </template>
        </Table>
      </div>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          show-total
          show-elevator
          :current="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          @on-change="handlePageChange"
        ></Page>
      </div>
      <Modal
        v-model="eduRecommendModal"
        title="选择教育局"
        width="1200"
        :mask-closable="false"
        ok-text="提交"
        @on-ok="handleSubmitRecommend"
        @on-cancel="cancelRecommend"
      >
        <div class="page_modal">
          <Form :label-width="800" inline>
            <FormItem label="教育局名称：">
              <Input
                v-model="educationBureauName"
                placeholder="请输入"
                style="width: 250px"
                clearable
              ></Input>
            </FormItem>
            <Button
              type="primary"
              class="btn"
              @click="getRecommendEdus"
            >查询</Button>
          </Form>
          <Table
            ref="eduselection"
            border
            :columns="modalEduColumn"
            :data="modalEduTableData"
            :loading="modalEduTableLoading"
            @on-selection-change="handleRecommendEdu"
          >
          </Table>
          <div class="page-wrap" style="margin-top: 20px; text-align: right">
            <Page
              :total="modalPageInfo.total"
              show-total
              show-elevator
              :current="modalPageInfo.pageNum"
              :page-size="modalPageInfo.pageSize"
              @on-change="handleModalPage"
            ></Page>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { regionDataList } from '@/utils/dictionary';
import operationAdmin from '@/request/operationAdmin/index.js';
import { opeEduListColumns } from '@/pages/assetsModules/manageData.js';
import { orgKindList, cooperationList, completeStatusList, reviewStateList, changeDictionaries } from '@/utils/dictionary.js';
import EditButton from '@/pages/assetsModules/EditButton';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'CompanyOrgMage',
  components: {
    EditButton
  },
  filters: {
    InitCooperateState(v) {
      switch (v) {
        case 1:
          return '正常';
        case 2:
          return '已停止合作';
      }
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      regionDataList: [...regionDataList],
      active: 1, // 选中哪个tab
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchConds: {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        area: [],
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null, // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
        reviewState: null // 教育局审批状态 0：未审批 1：通过 2：不通过
      },
      // tableColumns: [...opeEduListColumns],
      orgKindList, // 单位类别列表
      cooperationList, // 合作状态列表
      completeStatusList, // 信息完善状态
      reviewStateList, // 教育局审批状态
      tableData: [],
      selectTableData: [], // 选中的数据
      selectOrgIds: '', // 选择的机构id
      eduRecommendModal: false, // 推荐至教育局的弹窗是否打开
      educationBureauName: '', // 教育局名称
      modalPageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      modalEduColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '教育局名称',
          key: 'name',
          align: 'center'
        },
        {
          title: '区域',
          key: 'areaName',
          align: 'center'
        }
      ],
      modalEduTableData: [], // 推荐到教育局的表格数据
      selectEduData: [],
      educationBureauIds: [], // 选择的教育局id
      tableLoading: false,
      modalEduTableLoading: false
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['routeTitle']),
    tableColumns() {
      if (this.userInfo.userType === 5) {
        return [
          {
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          },
          ...opeEduListColumns,
          {
            title: '创建账号',
            key: 'creatorName',
            minWidth: 180,
            align: 'center'
          },
          {
            title: '教育局审批状态',
            key: 'reviewState',
            minWidth: 180,
            align: 'center',
            render: (h, params) => {
              return h('div', {
                class: {
                  'check-status-430': params.row.reviewState === 0,
                  'pass-status-430': params.row.reviewState === 1,
                  'stop-status-430': params.row.reviewState === 2
                }
              }, [changeDictionaries(reviewStateList)[params.row.reviewState]]);
            }
          }
        ];
      } else {
        return [
          {
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          },
          ...opeEduListColumns
        ];
      }
    }
  },
  created() {
    this.getOrgList();
    // this.tableColumns.unshift({
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    //   fixed: 'left'
    // });
    // 超管账号
    // if (this.userInfo.userType === 5) {
    //   this.tableColumns.push({
    //     title: '创建账号',
    //     key: 'creatorName',
    //     minWidth: 180,
    //     align: 'center'
    //   });
    //   this.tableColumns.push({
    //     title: '教育局审批状态',
    //     key: 'reviewState',
    //     minWidth: 180,
    //     align: 'center',
    //     render: (h, params) => {
    //       return h('div', {
    //         class: {
    //           'check-status-430': params.row.reviewState === 0,
    //           'pass-status-430': params.row.reviewState === 1,
    //           'stop-status-430': params.row.reviewState === 2
    //         }
    //       }, [changeDictionaries(reviewStateList)[params.row.reviewState]]);
    //     }
    //   });
    // }
  },
  activated() {
    this.getOrgList();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CompanyOrgMage');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.searchConds.area = value;
      this.searchConds.areaCode = value[value.length - 1];
    },
    // 重置
    handleReset() {
      this.searchConds = {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
      };
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.getOrgList();
    },
    // 服务机构详情
    handleToDetail(row, index) {
      this.$router.push({
        name: 'resource_organdetail',
        query: { orgId: row.orgId, active: 1 }
      });
    },
    // 跳转管理
    handleToMage(row) {
      this.$router.push({
        name: 'basicInfoCenter_company_orgByopeAction',
        query: { orgId: row.orgId, active: 1 }
      });
    },
    handleClickTab(name) {
      this.active = Number(name);
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 查询服务机构列表
    async getOrgList() {
      const { total, ...pageInfo } = this.pageInfo;
      const { area, ...searchConds } = this.searchConds;
      const params = { ...pageInfo, ...searchConds };
      let res = {};
      this.tableLoading = true;
      if (this.active === 1) {
        res = await operationAdmin.getOrgListNew(params);
      } else if (this.active === 2) {
        res = await operationAdmin.getOrgListNewNoCoo(params);
      }
      this.tableLoading = false;
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 获取表格选中的数据
    handleSelectData(selection) {
      this.selectTableData = selection;
      this.selectOrgIds = '';
      this.selectTableData.forEach((item, index) => {
        if (index === 0) {
          this.selectOrgIds += item.orgId;
        } else {
          this.selectOrgIds += ',' + item.orgId;
        }
      });
    },
    // 获取选择的教育局
    handleRecommendEdu(selection) {
      this.selectEduData = selection;
      this.educationBureauIds = [];
      this.selectEduData.forEach((item, index) => {
        this.educationBureauIds.push(item.orgId);
      });
    },
    // 推荐到教育局
    async handleRecommend() {
      if (this.selectTableData.length === 0) {
        return this.$Message.error('请勾选一条记录');
      }
      if (this.selectTableData.length !== 1) {
        return this.$Message.error('只能勾选一条记录');
      }
      await this.getRecommendEdus();
      this.eduRecommendModal = true;
    },
    // 获取可以推荐的教育局列表
    async getRecommendEdus() {
      const params = {
        orgId: this.selectTableData[0].orgId,
        pageNum: this.modalPageInfo.pageNum,
        pageSize: this.modalPageInfo.pageSize,
        educationBureauName: this.educationBureauName
      };
      this.modalEduTableLoading = true;
      const res = await operationAdmin.getRecommendEdus(params);
      this.modalEduTableLoading = false;
      if (res.status === 200) {
        this.modalEduTableData = res.message.list;
        this.modalPageInfo.total = Number(res.message.total);
      }
    },
    // 提交推荐教育局
    async handleSubmitRecommend() {
      if (this.educationBureauIds.length === 0) {
        return this.$Message.error('请勾选到要推荐到的教育局');
      }
      const params = {
        educationBureauIds: this.educationBureauIds,
        orgId: this.selectOrgIds
      };
      const res = await operationAdmin.postOrgRecommendsNew(params);
      if (res.status === 200) {
        this.$Message.success('提交成功');
        this.eduRecommendModal = false;
        this.getOrgList();
      }
    },
    // 取消推荐到教育局
    cancelRecommend() {
      this.eduRecommendModal = false;
      this.educationBureauName = '';
      this.modalPageInfo = {
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
      this.educationBureauIds = [];
      this.selectEduData = [];
    },
    handleModalPage(num) {
      this.modalPageInfo.pageNum = num;
      this.getRecommendEdus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container {
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  .green {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: green;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
  .purple {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: purple;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
}
.col-center {
  padding: 0 8px;
  margin-bottom: 8px;
  button + button {
    margin-left: 16px;
  }
}
.tabs-block {
  display: flex;
  margin: 8px 0 24px 0;
  border-bottom: 1px solid #ccc;
  .tab-item {
    padding: 16px 32px;
    border-bottom: 2px solid transparent;
    font-size: 16px;
  }
  .tab-item-active {
    color: #488ffa;
    border-bottom: 2px solid #488ffa;
  }
  .tab-item + .tab-item {
    margin-left: 16px;
  }
}
</style>
